import {Action} from '@ngrx/store';
import {PagingModel} from '../models/paging-model';
import {User} from '../models/user';
import {AdminUserResponse} from '../models/admin-user-response';
import {KvItem} from '../models/kv-item';
import { ErrorModel } from '../models/error-model';

export const LOAD_USER_LIST = '[User] LoadUserList';
export const LOAD_USER_LIST_COMPLETE = '[User] LoadUserListComplete';
export const LOAD_USER_ROLES = '[User] LoadUserRoles';
export const LOAD_USER_ROLES_COMPLETE = '[User] LoadUserRolesComplete';
export const LOAD_USER_DETAILS = '[User] LoadUserDetails';
export const LOAD_USER_DETAILS_COMPLETE = '[User] LoadUserDetailsComplete';
export const SAVE_USER_DETAILS = '[User] SaveUserDetails';
export const SAVE_USER_DETAILS_COMPLETE = '[User] SaveUserDetailsComplete';
export const IGNORE = '[User] Ignore';
export const CHECK_USERNAME_EXISTS = '[User] CheckUsernameExists';
export const CHECK_USERNAME_EXISTS_COMPLETE = '[User] CheckUsernameExistsComplete';
export const CHECK_EMAIL_EXISTS = '[User] CheckEmailExists';
export const CHECK_EMAIL_EXISTS_COMPLETE = '[User] CheckEmailExistsComplete';
export const TOGGLE_ENABLED = '[User] ToggleEnabled';
export const TOGGLE_ENABLED_COMPLETE = '[User] ToggleEnabledComplete';
export const ACCEPT_USER_AGREEMENT = '[User] Accept Agreement';
export const ACCEPT_USER_AGREEMENT_COMPLETE = '[User] Accept Agreement Complete';
export const REGISTER_MFA = '[User] Register MFA';
export const REGISTER_MFA_COMPLETE = '[User] Register MFA Complete';

export class LoadUserListAction implements Action {
  readonly type = LOAD_USER_LIST;

  constructor(public payload: PagingModel) {}
}

export class LoadUserRolesAction implements Action {
  readonly type = LOAD_USER_ROLES;
}

export class LoadUserDetailsAction implements Action {
  readonly type = LOAD_USER_DETAILS;

  constructor(public payload: string) {}
}

export class SaveUserDetailsAction implements Action {
  readonly type = SAVE_USER_DETAILS;

  constructor(public payload: User) {}
}

export class LoadUserListCompleteAction implements Action {
  readonly type = LOAD_USER_LIST_COMPLETE;

  constructor(public payload: AdminUserResponse) {}
}

export class LoadUserRolesCompleteAction implements Action {
  readonly type = LOAD_USER_ROLES_COMPLETE;

  constructor(public payload: KvItem[]) {}
}

export class LoadUserDetailsCompleteAction implements Action {
  readonly type = LOAD_USER_DETAILS_COMPLETE;

  constructor(public payload: User) {}
}

export class SaveUserDetailsCompleteAction implements Action {
  readonly type = SAVE_USER_DETAILS_COMPLETE;

  constructor(public payload: string) {}
}

export class CheckUsernameExistsAction implements Action {
  readonly type = CHECK_USERNAME_EXISTS;

  constructor(public payload: string) { }
}

export class CheckUsernameExistsCompleteAction implements Action {
  readonly type = CHECK_USERNAME_EXISTS_COMPLETE;

  constructor(public payload: boolean) { }
}

export class CheckEmailExistsAction implements Action {
  readonly type = CHECK_EMAIL_EXISTS;

  constructor(public payload: string) { }
}

export class CheckEmailExistsCompleteAction implements Action {
  readonly type = CHECK_EMAIL_EXISTS_COMPLETE;

  constructor(public payload: boolean) { }
}

export class ToggleEnabledAction implements Action {
  readonly type = TOGGLE_ENABLED;

  constructor(public payload: number) { }
}

export class ToggleEnabledCompleteAction implements Action {
  readonly type = TOGGLE_ENABLED_COMPLETE;

  constructor(public payload: number) { }
}

export class AcceptUserAgreementAction implements Action {
  readonly type = ACCEPT_USER_AGREEMENT;
}

export class AcceptUserAgreementCompleteAction implements Action {
  readonly type = ACCEPT_USER_AGREEMENT_COMPLETE;

  constructor(public payload: boolean) {}
}

export class RegisterMfaAction implements  Action {
  readonly type = REGISTER_MFA;
  constructor(public payload: string) {}
}

export class RegisterMfaCompleteAction implements  Action {
  readonly type = REGISTER_MFA_COMPLETE;
  constructor(public payload: boolean) {}
}

export type Actions = LoadUserListAction |
  LoadUserListCompleteAction |
  LoadUserRolesAction |
  LoadUserRolesCompleteAction |
  LoadUserDetailsAction |
  LoadUserDetailsCompleteAction |
  SaveUserDetailsAction |
  SaveUserDetailsCompleteAction |
  CheckUsernameExistsAction |
  CheckUsernameExistsCompleteAction |
  CheckEmailExistsAction |
  CheckEmailExistsCompleteAction |
  ToggleEnabledAction |
  ToggleEnabledCompleteAction |
  AcceptUserAgreementAction |
  AcceptUserAgreementCompleteAction |
    RegisterMfaAction | RegisterMfaCompleteAction;



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/actions/user.ts